import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RuleForm from '../inputs/RuleForm';
import InlineSupplierSelect from '../inputs/InlineSupplierSelect';


class PricingTierRule extends Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.onReset = this.onReset.bind(this);
    const { initialValues } = props;
    this.initialState = {
      supplier: initialValues.supplier || 1
    };
    this.state = this.initialState;
  }

  onSubmit(event) {
    event.preventDefault();
    this.props.onSubmit({
      kind: 'pricing_tier',
      value: this.state
    });
  }

  onReset() {
    this.setState(this.initialState);
  }

  render() {
    const { form, type, ...other } = this.props;
    const { supplier } = this.state;

    return (
      <RuleForm
        {...other}
        onSubmit={this.onSubmit}
        onReset={this.onReset}
        isSubmitting={form.is_submitting}
      >
        <InlineSupplierSelect
          value={supplier}
          onChange={supplier_id => this.setState({ supplier: supplier_id })}
          required={true}
        />
      </RuleForm>
    );
  }
}

PricingTierRule.defaultProps = {
  type: 'add',
  initialValues: {}
};

PricingTierRule.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  form: PropTypes.object,
  type: PropTypes.string,
  initialValues: PropTypes.object,
};

export default PricingTierRule;
